<template>
  <div>
    <PageAllow controller="Receipt" action="billAnalyze" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-menu
                v-if="
                ((this.options.obj_type == 1 ||
                    this.options.obj_type == null) &&
                  $permission.permissionAllow(
                    'Receipt',
                    'billAnalyzeShopOrderExport'
                  )) || ((this.options.obj_type == 1 ||
                    this.options.obj_type == null) &&
                  $permission.permissionAllow(
                    'Receipt',
                    'billAnalyzeCountExport'
                  )) || (!this.options.obj_type == 1)
                  || ($permission.permissionAllow('Receipt', 'billAnalyzeExport'))
                "
                  v-model="exportBtnMenu"
                  open-on-hover
                  close-on-click
                  close-on-content-click
                  offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-file-export</v-icon>
                    {{ $t("ReceiptBillAnalyze.batchExports") }}
                    <v-icon x-small class="ps-1">
                      {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 要货对账单批量下载 -->
                  <v-list-item
                    v-if="
                      (this.options.obj_type == 1 ||
                        this.options.obj_type == null) &&
                      $permission.permissionAllow(
                        'Receipt',
                        'billAnalyzeShopOrderExport'
                      )
                    "
                    @click.stop="billAnalyzeShopOrderExport()"
                  >
                    <v-list-item-title>
                      {{ $t("ReceiptBillAnalyze.accountBatchDownload") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 应收应付统计下载 -->
                  <v-list-item
                    v-if="
                      (this.options.obj_type == 1 ||
                        this.options.obj_type == null) &&
                      $permission.permissionAllow(
                        'Receipt',
                        'billAnalyzeCountExport'
                      )
                    "
                    @click.stop="billAnalyzeCountExport()"
                  >
                    <v-list-item-title>
                      {{ $t("ReceiptBillAnalyze.receiptBillAnalyzeDownload") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 采购对账单统计下载 -->
                  <v-list-item v-if="!this.options.obj_type == 1">
                    <v-list-item-title>
                      {{ $t("ReceiptBillAnalyze.billTypeSupplierDownload") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 导出excel -->
                  <v-list-item
                    v-if="$permission.permissionAllow('Receipt', 'billAnalyzeExport')"
                    @click.stop="billAnalyzeExport()"
                  >
                    <v-list-item-title>
                      {{ $t("ReceiptBillAnalyze.export") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                small
                color="primary"
                dark
                class="ms-1"
                v-if="$permission.permissionAllow('Receipt', 'billAnalyzeHistory')"
                :href="'/#/receipt-bill-analyze/history'"
              >
                {{ $t("ReceiptBillAnalyze.billAnalyzeHistory") }}
              </v-btn>
              <v-btn
                small
                color="primary"
                dark
                class="ms-1"
                v-if="$permission.permissionAllow('MaterialProfitAnalyzeHistories', 'index')"
                :href="'/#/receipt-bill-analyze/material-analyze-histories'"
              >
                {{ $t("ReceiptBillAnalyze.materialProfitAnalyzeHistories") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherObjType v-model="options.obj_type" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherBillType
                    v-model="options.bill_types"
                    :obj-type="options.obj_type"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="options.obj_type == 1 || options.obj_type == 2">
                  <SearcherKeyword
                    ref="obj_name"
                    v-model="options.obj_name"
                    @text="Keyword = $event"
                    :label="
                      $t(
                        'ReceiptBillAnalyze.Fields.name_code',
                        options.obj_type == 1
                          ? [$consts.shopName()]
                          : [$t('ReceiptBillAnalyze.Fields.supplier')]
                      )
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants v-model="DistrictsSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="options.obj_type == 2"
                >
                  <SearcherStock v-model="stocksSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="options.obj_type == 3"
                >
                  <SearcherStock v-model="stocksSelected" :identity-type="[2]"/>
                </v-col>
                <!-- 财务状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('ReceiptBillAnalyze.payFlgs.title')"
                    :items="$consts.financeFlgs"
                    v-model="options.pay_flg"
                  />
                </v-col>
                <!-- 对账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('ReceiptBillAnalyze.billCheckFlg.title')"
                    :items="$consts.billCheckFlg"
                    v-model="options.bill_check_flg"
                  />
                </v-col>
                <!-- 归账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('ReceiptBillAnalyze.billStatus.title')"
                    :items="$consts.billFlgs"
                    v-model="options.bill_status"
                  />
                </v-col>
                <!-- 作废状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('ReceiptBillAnalyze.cancelFlgs.title')"
                    :items="$consts.cancelFlgs"
                    v-model="options.cancel_flgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 汇总 -->
        <div class="mx-4 mb-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("Receipt.receivable") }}</h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content
                    >{{ $t("Receipt.receivable_fee_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ receive.receivable_fee_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.received_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ receive.received_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.wait_receive")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ receive.wait_receive | formatMoney }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("Receipt.payable") }}</h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content
                    >{{ $t("Receipt.pay_fee_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{ pay.pay_fee_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.paid_total")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money") }}{{ pay.paid_total | formatMoney }}
                  </v-list-item-content>
                  <v-list-item-content
                    >{{ $t("Receipt.wait_pay")
                    }}{{ $t("Global.colon") }}</v-list-item-content
                  >
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money") }}{{ pay.wait_pay | formatMoney }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ receive.receivable_fee_total | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ receive.received_total | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ receive.wait_receive | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ pay.pay_fee_total | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ pay.paid_total | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ pay.wait_pay | formatMoney }}
                  </span>
                </td>
                <td v-if="options && options.obj_type == 1"></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.receivable_fee_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ receive.receivable_fee_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.received_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ receive.received_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.wait_receive") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ receive.wait_receive | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.pay_fee_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ pay.pay_fee_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.paid_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ pay.paid_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReceiptBillAnalyze.Fields.wait_pay") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ pay.wait_pay | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.receivable_fee_total="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              {{ $t("Global.money")
              }}{{ item.receivable_fee_total | formatMoney }}
            </template>
            <template v-slot:item.received_total="{ item }">
              {{ $t("Global.money") }}{{ item.received_total | formatMoney }}
            </template>
            <template v-slot:item.wait_receive="{ item }">
              {{ $t("Global.money") }}{{ item.wait_receive | formatMoney }}
            </template>
            <template v-slot:item.pay_fee_total="{ item }">
              {{ $t("Global.money") }}{{ item.pay_fee_total | formatMoney }}
            </template>
            <template v-slot:item.paid_total="{ item }">
              {{ $t("Global.money") }}{{ item.paid_total | formatMoney }}
            </template>
            <template v-slot:item.wait_pay="{ item }">
              {{ $t("Global.money") }}{{ item.wait_pay | formatMoney }}
            </template>

            <!-- 按钮  -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="
                      $permission.permissionAllow(
                        'Receipt',
                        'billAnalyzeShopOrderExport'
                      )
                    "
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    @click.stop="exportOne(item)"
                  >
                    <v-icon x-small class="pe-1">fa-file-export</v-icon>
                    {{ $t("ReceiptBillAnalyze.accountDownload") }}
                  </v-btn>
                </template>
                <span>{{ $t("ReceiptBillAnalyze.accountDownload") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherBillType from "@/components/plugins/SearcherBillType";
import SearcherObjType from "@/components/plugins/SearcherObjType";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import receipBillAnalyze from "@/api/receip_bill_analyze";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherStock from "@/components/plugins/SearcherStock";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  district_ids: [],
  pay_flg: [1, 2, 3],
  bill_check_flg: [0, 1],
  bill_status: [0, 1],
  cancel_flgs: [0],
  bill_types: null,
  obj_type: 1,
  obj_name: "",
  stock_districts: null,
  stock_id: null,
};

export default {
  data: () => ({
    bills: [],
    stocksSelected: null,
    Keyword: "",
    DistrictsSelected: [],
    exportBtnMenu: false,
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("receipt-bill-analyzes-options")
        ? sessionStorage.getItem("receipt-bill-analyzes-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    pay: {},
    receive: {},
    receive_receivable_fee_total: 0,
    receive_received_total: 0,
    receive_wait_receive: 0,
    pay_pay_fee_total: 0,
    pay_paid_total: 0,
    pay_wait_pay: 0,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherKeyword,
    SearcherBillType,
    SearcherObjType,
    SearcherDistrictsWithDescendants,
    SearcherStock,
    SearcherStatus,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receiptBillAnalyze"),
        disabled: true,
        href: "/receipt-bill-analyze",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ReceiptBillAnalyze.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("ReceiptBillAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [];
      if (this.options.obj_type == 2 || this.options.obj_type == 3) {
        if (this.options.obj_type == 2) {
          headers.push(
            {
              text: i18n.t("ReceiptBillAnalyze.Fields.supplier_name"),
              align: "start",
              sortable: false,
              value: "supplier_name",
            },
            {
              text: i18n.t("ReceiptBillAnalyze.Fields.supplier_code"),
              align: "start",
              sortable: false,
              value: "supplier_code",
            },
          )
        }
        if (this.options.obj_type == 3) {
          headers.push(
            {
              text: i18n.t("ReceiptBillAnalyze.Fields.stock_name"),
              align: "start",
              sortable: false,
              value: "name",
            },
            {
              text: i18n.t("ReceiptBillAnalyze.Fields.stock_code"),
              align: "start",
              sortable: false,
              value: "code",
            },
          )
        }
        headers.push(
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.receivable_fee_total"),
            align: "end",
            sortable: false,
            value: "receivable_fee_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.received_total"),
            align: "end",
            sortable: false,
            value: "received_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.wait_receive"),
            align: "end",
            sortable: false,
            value: "wait_receive",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.pay_fee_total"),
            align: "end",
            sortable: false,
            value: "pay_fee_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.paid_total"),
            align: "end",
            sortable: false,
            value: "paid_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.wait_pay"),
            align: "end",
            sortable: false,
            value: "wait_pay",
          }
        );
      } else {
        headers.push(
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.shop_name"),
            align: "start",
            sortable: false,
            value: "shop_name",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.shop_code"),
            align: "start",
            sortable: false,
            value: "shop_code",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.receivable_fee_total"),
            align: "end",
            sortable: false,
            value: "receivable_fee_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.received_total"),
            align: "end",
            sortable: false,
            value: "received_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.wait_receive"),
            align: "end",
            sortable: false,
            value: "wait_receive",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.pay_fee_total"),
            align: "end",
            sortable: false,
            value: "pay_fee_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.paid_total"),
            align: "end",
            sortable: false,
            value: "paid_total",
          },
          {
            text: i18n.t("ReceiptBillAnalyze.Fields.wait_pay"),
            align: "end",
            sortable: false,
            value: "wait_pay",
          },
          {
            text: i18n.t("TableHeaders.actions"),
            align: "start",
            sortable: false,
            value: "actions",
          }
        );
      }
      return headers;
    },
    ...mapState(["stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("receipt-bill-analyzes", ["DistrictsSelected", "stocksSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        obj_name: this.Keyword,
      });
    },
    resetSearch() {
      this.stocksSelected = null;
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStockDetailsFromAPI() {
      this.loading = true;
      receipBillAnalyze.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bills = response.data.bills;
            this.pay = response.data.pay;
            this.receive = response.data.receive;
            this.receive_receivable_fee_total =
              response.data.receive.receivable_fee_total;
            this.receive_received_total = response.data.receive.received_total;
            this.receive_wait_receive = response.data.receive.wait_receive;
            this.pay_pay_fee_total = response.data.pay.pay_fee_total;
            this.pay_paid_total = response.data.pay.paid_total;
            this.pay_wait_pay = response.data.pay.wait_pay;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    billAnalyzeCountExport() {
      receipBillAnalyze.billAnalyzeCountExport(Object.assign({}, this.options));
    },
    billAnalyzeShopOrderExport() {
      receipBillAnalyze.billAnalyzeShopOrderExport(
        Object.assign({}, this.options)
      );
    },
    billAnalyzeExport() {
      receipBillAnalyze.billAnalyzeExport(Object.assign({}, this.options));
    },

    exportOne(e) {
      receipBillAnalyze.exportOne(e.shop_id, Object.assign({}, this.options));
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockDetailsFromAPI();
        sessionStorage.setItem("receipt-bill-analyzes-options", JSON.stringify(this.options));
      },
    },
    // 组别
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "receipt-bill-analyzes-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_id = this.stocksSelected
          ? this.stocksSelected.id
          : null;
        sessionStorage.setItem(
          "receipt-bill-analyzes-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>